// 引入 Vue
import Vue from 'vue';
// 引入 App 组件
import App from './App.vue';

// 引入 vue-router 并使用插件
import VueRouter from 'vue-router';
import router from './router';
Vue.use(VueRouter);

// 完整引入 ElementUI 组件库及样式
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 应用 ElementUI 插件
Vue.use(ElementUI);

// 引入消息提示插件并使用
import messagePlugin from './utils/messageprompt';
Vue.use(messagePlugin);

//引入自定义的文字懒加载插件
import {lazyPlugin} from '@/plugins/textContent';
Vue.use(lazyPlugin);

// 引入自定义的 Loading 插件
import LoadingPlugin from '@/plugins/LoadingPlugin'
Vue.use(LoadingPlugin)

import { overlayDirective } from '@/plugins/overlay'
Vue.directive('overlay', overlayDirective)

// 引入 Vuex store
import store from './store/index';

// import './assets/css/tailwind.css'
// import 'font-awesome/css/font-awesome.min.css'

// 关闭 Vue 的生产提示
Vue.config.productionTip = false;


// 创建 Vue 实例
new Vue({
    el: '#app',
    render: h => h(App),
    router,
    store,
    beforeCreate() {
        // 安装全局事件总线
        Vue.prototype.$bus = this;
    }
});
// 同步消息框位置
const syncMessagePosition = () => {
    const messages = document.querySelectorAll('.el-message');
    messages.forEach(msg => {
        const visibleTop = window.scrollY || document.documentElement.scrollTop;
        msg.style.top = `${visibleTop + 20}px`;
    });
};

// 监听所有可能改变滚动位置的事件
['scroll', 'resize', 'touchmove'].forEach(event => {
    window.addEventListener(event, syncMessagePosition, { passive: true });
});
// main.js 或全局错误处理文件
// main.js 或全局错误处理文件
Vue.config.errorHandler = (err, vm, info) => {
  // 判断是否是 406 错误且当前路由是登录页
  const is406 = err instanceof Error && err.message.includes('406');
  const is401 = err instanceof Error && err.message.includes('401');
  const isLoginRoute = router.currentRoute.path === '/login';
  
  if (is406 && isLoginRoute || is401 && isLoginRoute) {
    // 406 错误且在登录页，不展示错误
    return; 
  }
  
  // 其他错误正常处理
  console.error('全局错误:', err, info);
  
  // 如果使用了 ElementUI 的消息提示，可以在这里统一处理
  vm.$message.error('系统错误，请稍后重试');
};

    